import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Users";
import { IUserDTO } from "app/api/types";
import getToken from "app/api/getToken";

export const UPDATE_USER_PROFILE_REQUEST = "UPDATE_USER_PROFILE_REQUEST";
export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_PROFILE_FAIL = "UPDATE_USER_PROFILE_FAIL";

export const updateUserProfile = (data: IUserDTO) => (dispatch: any): any => {
  dispatch({ type: UPDATE_USER_PROFILE_REQUEST });

  const token = getToken();

  return api
    .updateUserProfile(token, data)
    .then((response: AxiosResponse) => {
      dispatch({ type: UPDATE_USER_PROFILE_SUCCESS });
    })
    .catch(err => {
      dispatch({
        type: UPDATE_USER_PROFILE_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
